<template>
  <SaveModal
      color="yellow"
      icon="mdi-content-duplicate"
      :maxWidth="maxWidth"
      button="Duplikovať"
      :itemKey="itemKey"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :saveData="duplicateData"
      @onSave="(response) => $emit('onDuplicate', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          Item,
          errors,
          ItemForm
        }"
    >
      <slot
          name="default"
          :Item="Item"
          :errors="errors"
          :ItemForm="ItemForm"
      />
    </template>
  </SaveModal>
</template>

<script>
  import SaveModal from '@/components/_Part/_Modal/Save'

  export default {
    name: 'Duplicate',
    props: [
      'maxWidth',
      'itemKey',
      'fetchData',
      'setTitle',
      'setItemForm',
      'duplicateData'
    ],
    emits: [
      'onDuplicate'
    ],
    components: {
      SaveModal
    }
  }
</script>
